import React, { MouseEvent, ChangeEvent, useState } from 'react';

import { injectIntl, IntlShape } from 'react-intl';

// axios
import axios from 'axios';
import { apiClient } from 'api-client';


// alerts
import { useSnackbar } from "notistack";

// redux
import { useDispatch } from 'react-redux';
import { setRefresh } from 'redux/actions/pageActions';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// icons
import { containerIcon } from 'assets/icons';

type Props = {
  intl: IntlShape,
  currentTime?: number | null,
  onCloseWindow: (bool: boolean) => void
}

const EditTimeDoorWarning = ( {intl, currentTime, onCloseWindow}: Props) => {
  
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const [time, setTime] = useState(null);

  const closeWindow = () => {
    onCloseWindow( false );
    setTime(null);
  } 

  // If submit, edit item
  const handleSubmit = async (e: MouseEvent<HTMLButtonElement> ) => {
    e.preventDefault();

    if ( time === currentTime || time === null ) {
      enqueueSnackbar(`${intl.formatMessage({id:'containerAlert.editDoorWarningTime.empty'})}`, { variant: 'error' });
    } else {
      editDoorWarningTime();
    };
  };

  const editDoorWarningTime = async () => {
    const cancelToken = axios.CancelToken.source();

    const newTime = time * 60;
    try {
      await apiClient.patch(`/v1/settings`, {
        doorOpenWarningAfter: newTime,
        cancelToken:cancelToken.token
      }
      ).then( ( response ) => {
        enqueueSnackbar(`${intl.formatMessage({id:'containerAlert.editDoorWarningTime.true'})}`, { variant: 'success' });
        dispatch(setRefresh( { refresh: true } ));
        setTime(null);
        closeWindow();
      });
    } catch ( error ) {
      console.log( 'err' );
      enqueueSnackbar(`${intl.formatMessage({id:'containerAlert.editDoorWarningTime.false'})}`, { variant: 'error' });
    }    
    return () => cancelToken.cancel();  
  }

  const handleInputAmount = ( e: ChangeEvent<HTMLInputElement>, newValue: string ) => {

    const value = parseInt(newValue);

    setTime(value);
  };

  return (
    <Grid container sx={{ position: 'fixed', top: '0%', left: '0%',
      backgroundColor:"rgba( 0, 0, 0, 0.5 ) !important", 
      width:"100vw", height:"100vh", zIndex:"1300" }}
    >

      <Card
        sx={{ 
          minWidth: "24rem", width: "auto", maxWidth: "27rem",
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          // backgroundColor: "#5ada55",
        }}
      >        

        <MDBox
          display="flex"
          flexDirection="column"
          p={2}
          m={0}
          sx={{ listStyle: "none" }}
        >    

          <MDBox sx= {{ display: "flex",
            flexDirection: "row", gap: "1rem" }} 
          >
            <MDBox className= "badge"
              sx={{ 
                // backgroundColor: "#17C063",
                p: 1, mt: -4, ml: 0,
                borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
              }}
              display="grid"
              justifyContent="center"
              alignItems="center"
              bgColor="#17C063"
              color="white"
              width="4.5rem"
              height="4.5rem"
              shadow="md"
              borderRadius="lg"
              variant="gradient"  
              fontSize= "2.2rem"        
            >
              {containerIcon}
            </MDBox>

            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
              }}
            >
              <MDTypography
                sx={{
                  fontSize: "1.2rem", fontWeight: "700",
                }}
              >
                {intl.formatMessage({id:'tableContainers.modal.title'})}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.75rem", fontWeight: "400",
                }}
              >
                { intl.formatMessage({id:'tableContainers.modal.currentTime'},{currentTime}) }
              </MDTypography>
            </MDBox>
                            
          </MDBox>

          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <MDBox
              sx={{
                display: "flex", flexDirection: "column", marginTop:"0.7rem",
                width: "47%",
              }}
            >
              <MDInput 
                type="text"
                name='amount'
                multiline
                rows={1} 
                // value= { finesForm.amount ? finesForm.amount : '' }
                placeholder={intl.formatMessage({id:'tableContainers.modal.placeholder'})}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputAmount(e, e.target.value)}
                InputProps={{
                  inputProps: {
                    onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
                      const allowedRegex = /^[0-9]$/;
                      if (!allowedRegex.test(e.key)) {
                        e.preventDefault();
                      }
                    },
                    inputMode: "decimal",
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#D2D6DA',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#7B809A',
                    opacity: 1,
                  },
                }}
              />
            </MDBox>
          </MDBox>

          <MDBox 
            sx={{
                display: "flex", flexDirection: "row", justifyContent: "flex-end", 
                gap: "0.5rem", maxWidth: "100%", marginBottom: "0.5rem", marginTop: "1rem",
            }}
          >
            <MDButton
              variant="outlined" 
              color="success" 
              // onClick={() => navigate(-1)}
              onClick={ closeWindow }
            >
              {intl.formatMessage({id:'button.cancel'})}
            </MDButton>
            <MDButton
              variant="contained" 
              color="warning" 
              onClick={ handleSubmit }         
            >
              {intl.formatMessage({id:'button.changeTime'})}
            </MDButton>
          </MDBox>
  
        </MDBox>
      </Card>
    </Grid>
  )
};

export default injectIntl(EditTimeDoorWarning);